/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovKoFnsIcon16Light } from './GovKoFnsIcon16Light';
import { GovKoFnsIcon16Regular } from './GovKoFnsIcon16Regular';
import { GovKoFnsIcon16Solid } from './GovKoFnsIcon16Solid';
import { GovKoFnsIcon20Light } from './GovKoFnsIcon20Light';
import { GovKoFnsIcon20Regular } from './GovKoFnsIcon20Regular';
import { GovKoFnsIcon20Solid } from './GovKoFnsIcon20Solid';
import { GovKoFnsIcon24Regular } from './GovKoFnsIcon24Regular';
import { GovKoFnsIcon24Solid } from './GovKoFnsIcon24Solid';
import { GovKoFnsIcon32Regular } from './GovKoFnsIcon32Regular';
import { GovKoFnsIcon64Regular } from './GovKoFnsIcon64Regular';
var sizes = {
    16: {
        light: GovKoFnsIcon16Light,
        regular: GovKoFnsIcon16Regular,
        solid: GovKoFnsIcon16Solid,
    },
    20: {
        light: GovKoFnsIcon20Light,
        regular: GovKoFnsIcon20Regular,
        solid: GovKoFnsIcon20Solid,
    },
    24: {
        regular: GovKoFnsIcon24Regular,
        solid: GovKoFnsIcon24Solid,
    },
    32: {
        regular: GovKoFnsIcon32Regular,
    },
    64: {
        regular: GovKoFnsIcon64Regular,
    },
};
export var GovKoFnsIcon = forwardRef('GovKoFnsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
